import { render } from "./documents.vue?vue&type=template&id=b3294802"
import script from "./documents.vue?vue&type=script&lang=js"
export * from "./documents.vue?vue&type=script&lang=js"

import "./documents.vue?vue&type=style&index=0&id=b3294802&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__